module.exports = __webpack_public_path__ + "static/media/remove_budget_icon_int-transactions.ded01fd1.svg";